import { ArrowLeftOutlined } from '@ant-design/icons';
import { EditAppButton } from './EditAppButton';
import { FULL_ROUTES } from '@sonar-software/sonar-ts-constants';
import { GoToDictionaryAppButton } from './GoToDictionaryAppButton';
import { HeaderWithButtonMenu } from '@ui/general';
import { HideAppButton } from './HideAppButton';
import { Link } from 'react-router-dom';
import { MonitorAppButton } from './MonitorAppButton';
import React from 'react';
import { RevokeAccessButton } from './RevokeAccessButton';
import { useApplicationReference } from '@hooks';

import { Button, Space } from 'antd';

export interface ApplicationOverviewHeaderProps {
	applicationId: number;
}

export const ApplicationOverviewHeader: React.FC<ApplicationOverviewHeaderProps> = ({ applicationId }) => {
	const { label, name } = useApplicationReference(applicationId);

	const nameDisplay = name ?? applicationId;
	const labelDisplay = label ? ` (${label})` : '';
	const displayName = `${nameDisplay}${labelDisplay}`;

	const title =
		<Space size='small'>
			<Link to={ FULL_ROUTES.DATA_SECURITY }>
				<Button
					className='back-to-overview-button'
					icon={ <ArrowLeftOutlined /> }
					type='link' />
			</Link>
			<div className='h2'>{ displayName }</div>
		</Space>;

	return (
		<HeaderWithButtonMenu
			title={ title }>
			<RevokeAccessButton applicationId={ applicationId } />
			<HideAppButton applicationId={ applicationId } />
			<GoToDictionaryAppButton applicationId={ applicationId } />
			<EditAppButton applicationId={ applicationId } />
			<MonitorAppButton applicationId={ applicationId } />
		</HeaderWithButtonMenu>
	);
};
